import { render, staticRenderFns } from "./resultCompany.vue?vue&type=template&id=e68f7e92&scoped=true&"
import script from "./resultCompany.vue?vue&type=script&lang=js&"
export * from "./resultCompany.vue?vue&type=script&lang=js&"
import style0 from "./resultCompany.vue?vue&type=style&index=0&id=e68f7e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68f7e92",
  null
  
)

export default component.exports